import {mapMutations, mapGetters} from 'vuex';

export function mapGettersAndMutations(moduleName, properties) {
  let result = {};

  let getters = mapGetters(moduleName, properties);
  let mutations = mapMutations(moduleName, properties);

  for (let property of properties) {
    result[property] = {
      get() {
        return getters[property].apply(this);
      },
      set(value) {
        return mutations[property].apply(this, [value]);
      }
    }
  }

  return result;
}

export function createGetters(properties) {
  let result = {};

  for (let property of properties) {
    result[property] = (
      function (prop) {
        return function(state) {
          return state[prop];
        }
      })(property);
  }

  return result;
}

export function createMutations(properties) {
  let result = {};

  for (let property of properties) {
    result[property] = (
      function (prop) {
        return function(state, value) {
          return state[prop] = value;
        }
      })(property);
  }

  return result;
}



// WEBPACK FOOTER //
// ./src/lib/vuex.js